import request from "@/utils/request";
const preFixUrl = "/registration";
// 药品
/**
 * 列表
 * @param {*} data
 * @returns
 */
export const getList = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryOfficeInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 科室医生
 * 医生列表
 * @param {*} data
 * @returns
 */
export const queryDoctorInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryDoctorInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};
/**
 * 医生排班 查询某个医生的排班
 * @param {*} data
 * @returns
 */
export const queryDoctorScheduleInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryDoctorScheduleInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 医生排班 查询号源信息服务
 * @param {*} data
 * @returns
 */
export const querySourceInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/querySourceInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询科室号源信息
 * @param {*} data
 * @returns
 */
export const queryResourceInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryResourceInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 预约挂号
 * @param {*} data
 * @returns
 */
export const submitOppointment = (data) => {
  return request({
    url: `${preFixUrl}/registration/submitOppointment`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};
/**
 * 预约挂号-新
 * @param {*} data
 * @returns
 */
export const submitOppointmentV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryGuaHaoYY2`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 预约记录
 * @param {*} data
 * @returns
 */
export const oppointmentRecord = (data) => {
  return request({
    url: `${preFixUrl}/appointment/listAppointment`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 挂号预约记录
 * 自己+就诊人
 * @param {*} data
 * @returns
 */
export const userListAppointment = (data) => {
  let dataQuery="";
  for (const key in data) {
    if(dataQuery){
      dataQuery=dataQuery+"&"+key+"="+data[key];
    }else{
      dataQuery=key+"="+data[key];
    }
  }
  console.log(dataQuery)
  return request({
    url: `${preFixUrl}/appointment/userListAppointment?${dataQuery}`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
  });
};

/**
 * 预约记录
 * @param {*} data
 * @returns
 */
export const updateAppointment = (data) => {
  return request({
    url: `${preFixUrl}/appointment/updateAppointment`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 取消-预约记录
 * @param {*} data
 * @returns
 */
export const cancelOppointment = (data) => {
  return request({
    url: `${preFixUrl}/registration/cancelOppointment`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 取消-预约记录-新
 * @param {*} data
 * @returns
 */
export const cancelOppointmentV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/GetGuaHaoYYQX3`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};


/**
 * 内镜预约记录
 * @param {*} data
 * @returns
 */
export const getEndoscopy = (data) => {
  return request({
    url: `${preFixUrl}/endoscopy/list`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 取消内镜预约记录
 * @param {*} params
 * @returns
 */
export const getEndoscopyCancel = (params) => {
  return request({
    url: `${preFixUrl}/endoscopy/cancel`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    params,
  });
};

/**
 * 查询院区代码
 * @param {*} params
 * @returns
 */
export const queryHosInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryHosInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询开放预约的科室信息
 * 查询科室列表
 * @param {*} params
 * @returns
 */
export const queryDepartmentInfo = (data) => {
  return request({
    url: `${preFixUrl}/registration/queryDepartmentInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询科室列表-新
 * @param {*} params
 * @returns
 */
export const queryDepartmentInfoV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryDXDepartmentInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询科室医生-新
 * @param {*} params
 * @returns
 */
export const queryDoctorInfoV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryDoctorInfo`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询医生排班-新
 * @param {*} params
 * @returns
 */
export const queryDoctorScheduleInfoV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryYiYuanPB`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 查询号源信息-新
 * @param {*} params
 * @returns
 */
export const querySourceInfoV2 = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryGuaHaoHYXX`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};

/**
 * 预约信息
 */
export const queryGuaHaoXXCX = (data) => {
  return request({
    url: `${preFixUrl}/registrationv2/queryGuaHaoXXCX`,
    method: "post",
    headers: {
      ["Content-Type"]: "application/json",
    },
    data,
  });
};